import { render, staticRenderFns } from "./recommend_load.vue?vue&type=template&id=1c34db52&scoped=true&"
import script from "./recommend_load.vue?vue&type=script&lang=js&"
export * from "./recommend_load.vue?vue&type=script&lang=js&"
import style0 from "./recommend_load.vue?vue&type=style&index=0&id=1c34db52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c34db52",
  null
  
)

export default component.exports